import ApiClient from '@/helpers/api/api.helpers';
class GeneralSettingApi extends ApiClient {
  constructor() {
    super('freepbx-setting/misc');
  }
}

export default new GeneralSettingApi();
